// Generated from icons/raw/search.svg by scripts/generate-icons.mjs. Do not edit.
import type { SVGProps } from "react";

export function SearchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 14 14"
      width={16}
      height={16}
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path d="M13 13L10.3333 10.3334M11.6667 6.33336C11.6667 9.27888 9.27885 11.6667 6.33333 11.6667C3.38781 11.6667 1 9.27888 1 6.33336C1 3.38785 3.38781 1.00003 6.33333 1.00003C9.27885 1.00003 11.6667 3.38785 11.6667 6.33336Z" stroke="currentColor" strokeWidth="1.14" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
